<template>
  <div class="support">
    <div class="support__content">
      <h1>Support</h1>
      <div
        v-html="this.dashboardDetailsInfo[0].SupportText"
        class="support__text"
      ></div>
    </div>
  </div>
</template>

<script>
import * as wsUtils from "@/utils/wsUtils.js";
import * as jsUtils from "@/utils/jsUtils.js";

export default {
  name: "Support",

  data() {
    return {
      dashboardDetailsInfo: [
        {
          AuthoringEnabled: false,
          ShelfLibraryEnabled: false,
          SupportEnabled: false,
        },
      ],
    };
  },
  computed: {},
  methods: {
    dashboardDetails() {
      const getDashboardDetails = new Promise((resolve) => {
        wsUtils.GetDashboardDetails(
          {
            userid: this.user.EncrypteduserID,
          },
          resolve
        );
      });

      getDashboardDetails.then((data) => {
        if (data.length !== 0) {
          this.dashboardDetailsInfo = data;
        }
        this.loadingDashboard = false;
      });
    },
  },
  created() {
    this.user = jsUtils.getUserInfo();
    this.dashboardDetails();
  },
  activated() {},
};
</script>

<style lang="scss" scoped>
.support {
  background: #f9f9f9;
  text-align: left;
  &__content {
    padding: 70px 77px;
    h1 {
      font-size: 23px;
      margin-bottom: 35px;
      color: #345364;
      border-bottom: 1px solid #e7e7e7;
      padding-bottom: 5px;
    }
  }
  &__text {
    max-width: 1000px;
    ::v-deep a {
      display: table;
      color: var(--hsblue);

      background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 64 64' xml:space='preserve'%3E%3Cpath d='M58.003 8H5.997a6 6 0 0 0-6 6v36a6 6 0 0 0 6 6h52.006a6 6 0 0 0 6-6V14a6 6 0 0 0-6-6zm4 41.11L43.085 30.193l18.918-12.056v30.975zM5.997 10h52.006c2.206 0 4 1.794 4 4v1.766L34.468 33.313c-1.49.95-3.394.92-4.85-.07L1.997 14.47V14c0-2.206 1.794-4 4-4zm-4 6.885 19.185 13.04L1.997 49.111V16.885zM58.003 54H5.997a4.005 4.005 0 0 1-3.677-2.428l20.52-20.52 5.655 3.844a6.41 6.41 0 0 0 7.046.104l5.842-3.724L61.68 51.572A4.005 4.005 0 0 1 58.003 54z'/%3E%3C/svg%3E")
        no-repeat 0 center;
      background-size: 16px;
      padding-left: 21px;
      margin-bottom: 4px;
    }
    ::v-deep > p {
      font-size: 15px;
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0;
      }
    }
    ::v-deep ul {
      margin: 0;
      padding: 0;
      li {
        margin-bottom: 24px;
        font-size: 14px;
        position: relative;
        &:after {
          position: absolute;
          left: 0;
          bottom: -12px;
          content: "";
          width: 40px;
          border-bottom: 1px solid lightgrey;
        }
        &:last-child {
          margin-bottom: 0;
          &::after {
            display: none;
          }
        }
        strong {
          font-weight: 500;
          margin-bottom: 4px;
          display: block;
        }
        p {
          background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 60.002 60.002' style='enable-background:new 0 0 60.002 60.002' xml:space='preserve'%3E%3Cpath d='M59.002 37.992a6.701 6.701 0 0 1-6.693-6.693 1 1 0 1 0-2 0c0 4.794 3.899 8.693 8.693 8.693a1 1 0 1 0 0-2z'/%3E%3Cpath d='M58.256 35.65a1 1 0 1 0 0-2c-.886 0-1.605-.72-1.605-1.605a1 1 0 1 0-2 0 3.608 3.608 0 0 0 3.605 3.605zM20.002 2.992a6.7 6.7 0 0 1 6.693 6.693 1 1 0 1 0 2 0c0-4.794-3.9-8.693-8.693-8.693a1 1 0 1 0 0 2z'/%3E%3Cpath d='M19.748 6.334a1 1 0 0 0 1 1c.885 0 1.604.72 1.604 1.605a1 1 0 1 0 2 0 3.609 3.609 0 0 0-3.604-3.605 1 1 0 0 0-1 1zM44.076 37.889c-1.276-.728-2.597-.958-3.721-.646-.844.234-1.532.768-1.996 1.546-1.02 1.22-2.286 2.646-2.592 2.867-2.367 1.604-4.25 1.415-6.294-.629L17.987 29.542c-2.045-2.045-2.233-3.928-.631-6.291.224-.31 1.65-1.575 2.87-2.596.778-.464 1.312-1.152 1.546-1.996.311-1.123.082-2.444-.652-3.731-.173-.296-4.291-7.27-8.085-9.277a4.909 4.909 0 0 0-5.796.872L4.7 9.059C.686 13.073-.767 17.622.379 22.579c.956 4.132 3.742 8.529 8.282 13.068l14.705 14.706c5.762 5.762 11.258 8.656 16.298 8.656 3.701 0 7.157-1.562 10.291-4.695l2.537-2.537a4.907 4.907 0 0 0 .872-5.796c-2.008-3.795-8.981-7.912-9.288-8.092zm7.002 12.474L48.541 52.9c-6.569 6.567-14.563 5.235-23.76-3.961L10.075 34.233c-4.271-4.271-6.877-8.344-7.747-12.104-.995-4.301.244-8.112 3.786-11.655l2.537-2.537a2.925 2.925 0 0 1 3.446-.518c3.293 1.743 7.256 8.454 7.29 8.511.449.787.62 1.608.457 2.196-.1.36-.324.634-.684.836l-.15.104c-.853.712-2.883 2.434-3.308 3.061-.612.904-1.018 1.792-1.231 2.665-.711-1.418-1.286-3.06-1.475-4.881a1.012 1.012 0 0 0-1.098-.892 1.002 1.002 0 0 0-.892 1.099c.722 6.953 6.129 11.479 6.359 11.668.025.02.054.028.08.045l10.613 10.613c.045.045.092.085.137.129.035.051.058.108.104.154.189.187 4.704 4.567 11.599 5.283a1.001 1.001 0 0 0 .206-1.99c-2.114-.219-3.987-.839-5.548-1.558.765-.23 1.543-.612 2.332-1.146.628-.426 2.35-2.455 3.061-3.308l.104-.151c.202-.359.476-.583.836-.684.588-.159 1.409.008 2.186.45.067.04 6.778 4.003 8.521 7.296a2.916 2.916 0 0 1-.518 3.444z'/%3E%3C/svg%3E")
            no-repeat 0 center;
          background-size: 16px;
          padding-left: 21px;
        }
      }
    }
  }
}
</style>
